import client from "libs/api/client";
import { appInsights } from "libs/app-insights";
import { errorWrap } from "libs/error";

export type Configs = {
  appInsightsConnectionString: string;
  enableMultilingualFunction: boolean;
};

export async function getConfig() {
  try {
    const startTime = Date.now();
    const { data } = await client.get<Configs>("/configs");
    const endTime = Date.now();
    appInsights.trackEvent({
      name: "GetConfig",
      properties: {
        Duration: endTime - startTime,
      },
    });
    return data;
  } catch (error) {
    // 주의! Appinsight의 Key 값도 포함하여 가져오지 못했으므로 Appinsight 로깅은 불가능합니다.
    throw errorWrap(error, `App을 실행하기 위한 기본 config 값을 가져오지 못함 (예: AppInsights Key)`);
  }
}
